import { emailVerificationHandler } from 'pages/authPage/sagas/common';
import { lnk } from 'lib/routes';
import Api from 'domain/api';

export default emailVerificationHandler(Api.confirmEmailOnStdReg, lnk('auth'));
